/**
 * What a web visit says of itself, and the link a web player shares. Pure
 * readers and builders, so they are pinned under Node.
 *
 * A shared link names the join token and nothing else:
 * `https://play.reavers.io/?join=<token>`. The server resolves the token to the
 * offering player's world (WMS `/api/worlds/launch`); nothing here reads it.
 */

/** The one query parameter a shared link carries. */
export const JOIN_PARAM = 'join';

/**
 * The body of WMS `/api/worlds/launch` for a web visit, or null when the visit
 * followed no link: a plain web visit is not a launch.
 */
export function readWebLaunch(search) {
    const token = (new URLSearchParams(search || '').get(JOIN_PARAM) || '').trim();
    return token ? { platform: 'web', join_token: token } : null;
}

/** The link a web player shares: this client's origin and the token. */
export function joinLink(origin, token) {
    return `${String(origin || '').replace(/\/+$/, '')}/?${JOIN_PARAM}=${encodeURIComponent(token)}`;
}
